import {Dispatch, Reducer} from 'react';

import {without} from 'ramda';

import {SourcingVehicleListItemResponseBody} from '@dms/api/core';

import {SourcingTableState} from '../../components/SourcingTable/types/SourcingTableState';

type Action<Row> =
  | {type: 'sort'; column: string; keepRealTime?: boolean}
  | {type: 'resetData'}
  | {type: 'changePage'; page: number}
  | {type: 'changeCheckedRows'; rows: Row[]}
  | {type: 'selectRow'; row: Row}
  | {type: 'expandRow'; row: Row; isExpanded: boolean}
  | {type: 'setRealTime'; isRealTime: boolean; orderBy?: string};

export type SourcingTableDispatch = Dispatch<Action<SourcingVehicleListItemResponseBody>>;

export const reducer: Reducer<SourcingTableState, Action<SourcingVehicleListItemResponseBody>> = (
  state,
  action
) => {
  switch (action.type) {
    case 'sort':
      return {
        ...state,
        orderBy: action.column,
        page: 1,
        isRealTime: action.keepRealTime ? state.isRealTime : false,
      };
    case 'resetData':
      return {
        ...state,
        page: 1,
        checkedRows: [],
        selectedRow: null,
        expandedRowIds: [],
      };
    case 'changePage':
      return {
        ...state,
        page: action.page,
      };
    case 'selectRow':
      return {
        ...state,
        selectedRow: action.row,
      };
    case 'changeCheckedRows':
      return {
        ...state,
        checkedRows: action.rows,
      };
    case 'expandRow':
      return {
        ...state,
        expandedRowIds: action.isExpanded
          ? [...state.expandedRowIds, action.row.sourcingVehicle?.adId]
          : without([action.row.sourcingVehicle?.adId], state.expandedRowIds),
      };
    case 'setRealTime':
      return {
        ...state,
        isRealTime: action.isRealTime,
        orderBy: action.isRealTime && action.orderBy ? action.orderBy : state.orderBy,
      };
    default:
      return state;
  }
};
